// extracted by mini-css-extract-plugin
export default {"container":"RepresentationSection_container__+xFgl","logoContainer":"RepresentationSection_logoContainer__6xOO+","logo":"RepresentationSection_logo__2n2kn"};